export default __webpack_public_path__ + "static/bunny-photo-8102e2f8c89acd53cd2dc7924f7da2fd.jpg";